import { SyncReconciliationStatus } from "../SyncReconciliationStatus";
import { atom } from "recoil";

export const syncReconciliationStatusAtom = atom<SyncReconciliationStatus>({
    key: "syncReconciliationStatusAtom",
    default: SyncReconciliationStatus.NOT_STARTED
});